module.exports = __webpack_public_path__ + "static/media/PC_Carrosel_FUNDAMENTOS_DE_DEVOPS.4468f0fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/fundamentos-devops/PC_Carrosel_FUNDAMENTOS_DE_DEVOPS.png
// module id = 283
// module chunks = 0